<template>
  <server-error-view />
</template>

<script>
  /*serverError view wrapper*/

  // components
  import serverErrorView from '../../views/serverErrorView/serverErrorView';

  export default {
    name: "serverError",
    components: {
      serverErrorView,
    }
  }
</script>

